require('./ProgramSchedule.scss');
require('./_View/ProgramSchedule_View_Number.scss');
require('./_View/ProgramSchedule_View_Text.scss');

const b = require('app/www/libs/b')('program-schedule');

const _isEqual = require('lodash/isEqual');

const React = require('react');
const PropTypes = require('prop-types');

const Metrika = require('app/www/libs/client/metrika');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const Button_Broadcasting = require('app/www/components/blocks/Button/_Broadcasting/Button_Broadcasting');
const Icon = require('app/www/components/blocks/Icon/Icon');
const Link = require('app/www/components/blocks/Link/Link');
const ProgramDescription = require('app/www/components/blocks/ProgramDescription/ProgramDescription');
const ResizeListener = require('app/www/components/blocks/ResizeListener/ResizeListener');
const TimeLine = require('app/www/components/blocks/TimeLine/TimeLine');
const Spin = require('app/www/components/blocks/Spin/Spin');

const MAX_EPISODES = 20;
const VISIBLE_EPISODES = 17;
const TOGGLE_DURATION = 200;

class ProgramSchedule extends React.PureComponent {

    constructor(props) {
        super(props);

        const {
            eventId,
            schedule,
        } = this.props;

        let eventsCount = 0;
        Object.keys(schedule).forEach(date => (eventsCount += schedule[date].items.length));

        this.state = {
            schedule,
            showEventsCount: 0,
            expandedEventId: eventId,
            loadingItems: false,
            updateTime: null,
        };

        this._items = {};

        this._onExpandItems = this._onExpandItems.bind(this);
        this._onToggleItem = this._onToggleItem.bind(this);
        this._toggleAllItems = this._toggleAllItems.bind(this);
        this._getAllEpisodes = this._getAllEpisodes.bind(this);
        this._onEventFinished = this._onEventFinished.bind(this);
        this._onClickButton = this._onClickButton.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        return !_isEqual(props.schedule, state.schedule) ? {
            schedule: props.schedule,
            loadingItems: false,
        } : null;
    }

    componentDidMount() {
        const {
            metrika,
            channel,
            moreEvents,
        } = this.props;

        if (moreEvents) {
            Metrika.trackParams('PROGRAM_PAGE', {
                action: 'show',
                component: 'channel_blocks',
                type: 'link_more_events',
                orderIndex: metrika.orderIndex,
                channelId: channel.id,
                programId: metrika.programId,
            });
        }
    }

    render() {
        const {isTouchButtons, scheduleViewStrategy} = this.props;
        const {schedule} = this.state;

        const hasMounted = typeof isTouchButtons !== 'undefined';

        const mods = {
            view: scheduleViewStrategy,
        };

        if (hasMounted) {
            mods.buttons = isTouchButtons ? 'touch' : 'not-touch';
        }

        const resizeListenerProps = {
            callback: this._toggleAllItems,
            throttle: 250,
        };

        const isFutureEvent = Object.keys(schedule).some(date => {
            return schedule[date].isFuture;
        });

        return (
            <div className={b(mods)}>
                <div className={b('schedule')}>
                    {this._renderSchedule(schedule, scheduleViewStrategy, hasMounted)}
                    {!isFutureEvent && this._renderExpandItemsButton()}
                </div>
                <ResizeListener {...resizeListenerProps} />
            </div>
        );
    }

    /**
     * @param {Object} schedule
     * @param {String} scheduleViewStrategy
     * @param {Boolean} hasMounted
     * @returns {Object}
     * @private
     */
    _renderSchedule(schedule, scheduleViewStrategy, hasMounted) {
        switch (scheduleViewStrategy) {
            case 'text':
                return Object.keys(schedule).map(date => {
                    let groupDateMods = {
                        weekend: schedule[date].isWeekend,
                        past: schedule[date].items.length === 1
                            && schedule[date].items[0].hasFinished,
                    };

                    return [
                        schedule[date].isFuture && this._renderExpandItemsButton(),
                        <div key={date} className={b('group')}>
                            <div className={b('group-content')}>
                                <div className={b('date', groupDateMods)}>{date}</div>
                                <div className={b('group-items')}>
                                    {schedule[date].items.map((event, i) => {
                                        const itemProps = this._buildItemProps(event);

                                        return (
                                            <div key={event.start + i} {...itemProps}>
                                                <div className={b('item-content')}>
                                                    <div className={b('item-meta')}>
                                                        <div className={b('item-time')}>
                                                            {event.startTime}
                                                        </div>
                                                        {hasMounted && this._renderBroadcastingButton(event)}
                                                        <div className={b('item-title')}>
                                                            {event.title}
                                                            {this._renderLive(event)}
                                                        </div>
                                                    </div>
                                                    {this._renderDescription(event)}
                                                    {this._renderProgress(event)}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>,
                    ];
                });
            case 'number':
                return Object.keys(schedule).map(date => {
                    const isExtra = schedule[date].items.length > MAX_EPISODES &&
                        !schedule[date].items.some((event, i) =>
                            this.state.expandedEventId === event.id && i >= VISIBLE_EPISODES
                        );

                    let items = schedule[date].items;

                    if (isExtra && !this.state[`showAll${date}`]) {
                        items = schedule[date].items.slice(0, VISIBLE_EPISODES);
                    }

                    return [
                        schedule[date].isFuture && this._renderExpandItemsButton(),
                        <div key={date} className={b('group')}>
                            <div className={b('date', {
                                weekend: schedule[date].isWeekend,
                                past: items.length === 1 && items[0].hasFinished,
                            })}>{date}</div>
                            <div className={b('group-items')}>
                                {items.map((event, i) => {
                                    const itemProps = this._buildItemProps(event);

                                    return (
                                        <div key={event.start + i} {...itemProps}>
                                            {hasMounted && this._renderBroadcastingButton(event)}
                                            <div className={b('item-time')}>
                                                {event.startTime}
                                            </div>
                                        </div>
                                    );
                                })}
                                {isExtra && this._renderAllEpisodesButton(date)}
                            </div>
                        </div>,
                    ];
                });
            default:
                return null;
        }
    }

    /**
     * @param {Object} event
     * @returns {Boolean}
     * @private
     */
    _isItemCollapsed(event) {
        const {expandedEventId} = this.state;
        return Boolean(event.hasDescription) && expandedEventId !== event.id;
    }

    _buildItemProps(event, mods) {
        const {updateTime} = this.state;
        const isPast = updateTime >= Date.parse(event.finish);

        let props = {
            className: b('item', Object.assign({
                past: event.hasFinished || isPast,
                now: updateTime >= Date.parse(event.start) && !isPast,
                description: event.hasDescription,
                collapsed: this._isItemCollapsed(event),
            }, mods || {})),
        };

        if (event.hasDescription) {
            props.onClick = () => {
                if (!this._hasSelection) {
                    this._onToggleItem(event.id);
                }
            };
        }

        return props;
    }

    _renderProgress(event) {
        const props = {
            start: event.start,
            finish: event.finish,
            onFinish: this._onEventFinished,
        };

        return (
            <TimeLine className={b('item-timeline')} {...props} />
        );
    }

    /**
     * Передача в сетке закончилась
     * @param {Number} updateTime;
     * @private
     */
    _onEventFinished(updateTime) {
        this.setState({
            updateTime: Date.parse(updateTime),
        });
    }

    /**
     * @param {Object} event
     * @returns {Object}
     * @private
     */
    _renderBroadcastingButton(event) {
        const {
            channel,
        } = this.props;

        if (event.isNow && channel.hasBroadcasting) {
            const {
                isTouchButtons,
                scheduleViewStrategy,
            } = this.props;

            const isTextSchedule = scheduleViewStrategy === 'text';
            const size = isTouchButtons && isTextSchedule ? 'm' : 's';

            const buttonBroadcastingProps = {
                key: channel.id,
                mods: isTouchButtons ? {
                    size,
                    theme: 'clear',
                    'only-icon': true,
                    touch: true,
                } : {
                    theme: 'grey',
                    size: 's',
                    pin: 'circle',
                    icon: 'bright',
                    'only-icon': true,
                },
                icon: {
                    size,
                },
                channelId: channel.id,
                streamChannel: channel.streamChannel,
                transliteratedFamilyTitle: channel.transliteratedFamilyTitle,
                onClick: this._onClickButton,
            };

            return <Button_Broadcasting {...buttonBroadcastingProps} />;
        }
    }

    /**
     * @param {Object} event
     * @returns {Object}
     * @private
     */
    _renderLive(event) {
        const iconProps = {
            className: b('item-live'),
            mods: {
                live: true,
                size: 's',
            },
        };

        return event.live && <Icon {...iconProps} />;
    }

    /**
     * @param {Object} event
     * @returns {Object|null}
     * @private
     */
    _renderDescription(event) {
        if (!event.hasDescription) {
            return null;
        }

        this._items[event.id] = {};

        const programDescriptionProps = {
            mods: {
                type: 'schedule',
            },
            lineNumber: !this._isItemCollapsed(event) && 3,
            lineHeight: 18,
            description: event.description,
            callback: () => this._toggleItem(event.id),
        };

        return (
            <div className={b('item-description')} ref={ref => (this._items[event.id].description = ref)}>
                <div className={b('item-description-holder')} ref={ref => (this._items[event.id].holder = ref)}>
                    <ProgramDescription {...programDescriptionProps} />
                </div>
            </div>
        );
    }

    /**
     * @returns {Object}
     * @private
     */
    _renderExpandItemsButton() {
        const {i18n, moreEvents: count} = this.props;
        const loadingItems = this.state.loadingItems;

        if (!count || count <= 0 && !loadingItems) {
            return null;
        }

        const spinProps = {
            mods: {
                size: 'xxs',
            },
        };

        const linkProps = {
            className: b('expand-items-button'),
            onClick: this._onExpandItems,
            children: i18n.get('program-schedule.expand-items-button-default'),
        };

        return (
            <div className={b('expand-items-wrap')}>
                {!loadingItems
                    ? <Link {...linkProps} />
                    : <Spin className={b('spin')} {...spinProps} />
                }
            </div>
        );
    }

    /**
     * @param {Number} eventId
     * @private
     */
    _onToggleItem(eventId) {
        const {
            metrika,
            channel,
        } = this.props;

        const isOpen = Boolean(this.state.expandedEventId !== eventId);

        if (isOpen) {
            Metrika.trackParams('PROGRAM_PAGE', {
                action: 'click',
                component: 'channel_blocks',
                type: 'event_description_unfold',
                orderIndex: metrika.orderIndex,
                channelId: channel.id,
                programId: metrika.programId,
            });
        }

        this.setState({
            expandedEventId: isOpen ? eventId : null,
        }, this._toggleAllItems);
    }

    /**
     * Устанавливаем высоты всех элементов расписания
     * @private
     */
    _toggleAllItems() {
        Object.keys(this._items).forEach(eventId => {
            this._toggleItem(eventId);
        });
    }

    /**
     * Устанавливаем высоту элемента расписания
     * @param {Number|String} eventId
     * @private
     */
    _toggleItem(eventId) {
        eventId = Number(eventId);
        let ref = this._items[eventId];
        let height = this.state.expandedEventId === eventId ? ref.holder.offsetHeight : 0;
        ref.description.style.height = `${height}px`;
        setTimeout(this.props.onToggleItem, TOGGLE_DURATION);
    }

    /**
     * Догружаем элементы расписания
     * @param {Event} evt
     * @private
     */
    _onExpandItems(evt) {
        evt.preventDefault();

        const {
            channel,
            metrika,
            onMoreEvents,
        } = this.props;
        const showEventsCount = this.state.showEventsCount + 1;
        const channelId = (channel || []).id;

        onMoreEvents(showEventsCount, channelId);

        Metrika.trackParams('PROGRAM_PAGE', {
            action: 'click',
            component: 'channel_blocks',
            type: 'link_more_events',
            orderIndex: metrika.orderIndex,
            channelId: channel.id,
            programId: metrika.programId,
        });

        this.setState({
            showEventsCount,
            loadingItems: true,
        });
    }

    _renderAllEpisodesButton(date) {
        if (this.state[`showAll${date}`]) {
            return null;
        }

        const {i18n} = this.props;
        const buttonProps = {
            className: b('all-episodes'),
            onClick: () => this._getAllEpisodes(date),
            children: i18n.get('program-schedule.all-episodes-button'),
        };

        return <span {...buttonProps} />;
    }

    /**
     * Развернуть полные сутки.
     * @param date
     * @see https://st.yandex-team.ru/TVFRONT-3684
     * @private
     */
    _getAllEpisodes(date) {
        const {onToggleItem} = this.props;

        this.setState({
            [`showAll${date}`]: true,
        }, onToggleItem);
    }

    /**
     * @param {Object} evt
     * @private
     */
    _onClickButton(evt) {
        if (evt) {
            evt.stopPropagation();
        }
    }

    /**
     * Определние выделенного текста
     * @returns {Boolean}
     * @private
     */
    get _hasSelection() {
        return Boolean(window.getSelection && window.getSelection().toString());
    }
}

ProgramSchedule.defaultProps = {
    onToggleItem: () => {},
};

ProgramSchedule.propTypes = {
    eventId: PropTypes.number,
    channel: PropTypes.object,
    schedule: PropTypes.object,
    scheduleViewStrategy: PropTypes.string.isRequired,
    onEventFinished: PropTypes.func.isRequired,
    isFutureEvent: PropTypes.bool,
    moreEvents: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]),
    metrika: PropTypes.object,
    onToggleItem: PropTypes.func,
};

module.exports = withReq(withI18n(ProgramSchedule));
